import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import { getDashboardMetrics } from '../api/dashboardApi';
import { dashboardKeys } from './dashboardKeys';

export function useGetDashboardMetrics() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: dashboardKeys.metrics(),
    queryFn: getDashboardMetrics,
    enabled: isAuthenticated,
    staleTime: 30 * 1000,
  });
}
